export { default as Form } from 'groups/components/form/GroupForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/form/index.js